import React from 'react';
import { connect } from 'react-redux';
import ConfigureSensorsPage from './ConfigureSensorsPage';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import { configureActions } from '../../../../../actions/configure.action';
import helper from '../../../../../utils/helper';

class ConfigureSensors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      alarmMaps: [],
      loading: false,
      errors: '',
      isFetching: false,
    };
    this.columns = [
      { dataField: 'groupName', text: 'Group', sort: true },
      { dataField: 'sensorName', text: 'Sensor Name', sort: true },
    ];
    this.defaultSorted = [
      {
        dataField: 'sensorName',
        order: 'asc',
      },
    ];
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.alarmMaps !== prevState.alarmMaps) {
      state.alarmMaps = nextProps.configure.alarmMaps;
    }
    state.errors = helper.centralizeError([nextProps.configure.errors]);
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    await this.props.getAIsAlarmMaps(id);
  }

  onConfigureSensors = (ids) => {
    const { id } = this.props.match.params;
    const params = [];
    this.state.alarmMaps.map((alarmIndicator) => {
      params.push({
        sensorId: alarmIndicator.sensorId,
        checked: ids.includes(alarmIndicator.sensorId) ? true : false,
      });
    });
    this.props
      .configAlarmIndicator(id, params)
      .then(() => this.props.history.goBack())
      .catch((err) => console.log(err));
  };

  render() {
    const { loading } = this.state;
    const { id } = this.props.match.params;
    const { remoteName } = helper.parseQueryString(this.props.location.search);
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <ConfigureSensorsPage
        {...this.state}
        onConfigureSensors={this.onConfigureSensors}
        columns={this.columns}
        defaultSorted={this.defaultSorted}
        alarmIndicatorId={id}
        remoteName={remoteName}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}
export default connect(mapStateToProps, configureActions)(ConfigureSensors);
